package com.gsb.vyapar.bhagya.presentation.bottomsheet

sealed class BottomSheets {
    data object AddEditCategory : BottomSheets()
    data object AddEditSubCategory : BottomSheets()
}